import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ProposalTile} from '../../../../model/proposal-tile';
import {Offer} from '../../../../model/offer/offer';
import {ProposalDetailPageActions} from '../../../../store/proposal/actions/proposal.actions';
import {Store} from '@ngrx/store';

@Component({
    selector: 'app-offer-status-change-modal',
    templateUrl: './offer-status-change-modal.component.html',
    styleUrls: ['./offer-status-change-modal.component.scss'],
    standalone: false
})
export class OfferStatusChangeModalComponent {
  @Input() proposalTile: ProposalTile;
  @Input() selectedOffer: Offer;
  @Output() deselectOffer = new EventEmitter<Offer>();

  @Input() showRetractOffer: boolean = false;
  @Output() showRetractOfferChange = new EventEmitter<boolean>();

  @Input() showAcceptOffer: boolean = false;
  @Output() showAcceptOfferChange = new EventEmitter<boolean>();

  includeCompanyName: boolean = true;
  includeCoverage: boolean = false;
  includeClausesAndConditions: boolean = false;
  includePremium: boolean = false;

  constructor(private readonly store: Store) {
  }

  closeRetractModal() {
    this.showRetractOffer = false;
    this.showRetractOfferChange.emit(false);
  }

  retractOffer() {
    this.store.dispatch(ProposalDetailPageActions.retractOffer({offerId: this.selectedOffer.offerId, proposalId: this.selectedOffer.proposalId}));
    this.closeRetractModal();
    this.selectedOffer = null;
    this.deselectOffer.emit(this.selectedOffer);
  }

  closeModal() {
    this.showAcceptOffer = false;
    this.showAcceptOfferChange.emit(false);

    // Reset toggles when modal closes
    this.includeCompanyName = true;
    this.includeCoverage = false;
    this.includeClausesAndConditions = false;
    this.includePremium = false;

  }

  acceptOffer() {
    const payload: any = {
      offerId: this.selectedOffer.offerId
    };

    if (this.selectedOffer.isLeading) {
      payload.includeCompanyName = this.includeCompanyName;
      payload.includeCoverage = this.includeCoverage;
      payload.includeClausesAndConditions = this.includeClausesAndConditions;
      payload.includePremium = this.includePremium;
    }

    payload.proposalId = this.proposalTile.id;

    this.closeModal();
    this.store.dispatch(ProposalDetailPageActions.acceptOffer(payload));
    this.selectedOffer = null;
    this.deselectOffer.emit(this.selectedOffer);
  }
}
